export const REMOVE_NOTIFICATION = "notifications/REMOVE_NOTIFICATION";
export const UPDATE_NOTIFICATIONS_LIST =
  "notifications/UPDATE_NOTIFICATIONS_LIST";
